import type { CustomChartSize, CustomChartType } from '@/entities/dashboards';
import { CUSTOM_CHART_SIZES, RECOMMENDED_CHART_SIZES } from '@/entities/dashboards';

/** i18n-ключи названий типов диаграмм: тип назван тем, что пользователь получит. */
export const CHART_TYPE_LABEL_KEY = {
  metric: 'qualityDashboard:presets.chartTypes.metric',
  'text-summary': 'qualityDashboard:presets.chartTypes.textSummary',
  heatmap: 'qualityDashboard:presets.chartTypes.heatmap',
  table: 'qualityDashboard:presets.chartTypes.table',
  'grouped-table': 'qualityDashboard:presets.chartTypes.groupedTable',
  bar: 'qualityDashboard:presets.chartTypes.bar',
  pie: 'qualityDashboard:presets.chartTypes.pie',
  line: 'qualityDashboard:presets.chartTypes.line',
  'conversation-list': 'qualityDashboard:presets.chartTypes.conversationList',
  'selection-breakdown': 'qualityDashboard:presets.chartTypes.selectionBreakdown',
} as const satisfies Record<CustomChartType, string>;

/** i18n-ключи названий размеров диаграммы — доли ширины сетки дашборда. */
export const CHART_SIZE_LABEL_KEY = {
  '1/5': 'qualityDashboard:presets.chartSizes.fifth',
  '1/4': 'qualityDashboard:presets.chartSizes.quarter',
  '1/3': 'qualityDashboard:presets.chartSizes.third',
  '2/5': 'qualityDashboard:presets.chartSizes.twoFifths',
  '1/2': 'qualityDashboard:presets.chartSizes.half',
  '3/5': 'qualityDashboard:presets.chartSizes.threeFifths',
  '2/3': 'qualityDashboard:presets.chartSizes.twoThirds',
  '3/4': 'qualityDashboard:presets.chartSizes.threeQuarters',
  '4/5': 'qualityDashboard:presets.chartSizes.fourFifths',
  full: 'qualityDashboard:presets.chartSizes.full',
} as const satisfies Record<CustomChartSize, string>;

/**
 * Размеры для выбранного типа: рекомендуемые впереди, остальные следом.
 * Ограничения тут нет — пользователь вправе выбрать любой размер каталога.
 */
export const sizesForType = (chartType: CustomChartType): CustomChartSize[] => {
  const recommended = RECOMMENDED_CHART_SIZES[chartType];
  return [...recommended, ...CUSTOM_CHART_SIZES.filter((size) => !recommended.includes(size))];
};

/** Размер рекомендован для этого типа диаграммы. */
export const isRecommendedSize = (chartType: CustomChartType, size: CustomChartSize): boolean =>
  RECOMMENDED_CHART_SIZES[chartType].includes(size);
